<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-服务-修改
    -->
    <el-dialog
    title="修改申报情况"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :append-to-body="true" 
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      
      <el-form-item label="申报日期" prop="remark">
         {{ form.create_times }}
        
        </el-form-item>


        <el-form-item label="申报人员" prop="remark">
         {{ form.create_times }}
        
        </el-form-item>



        <el-form-item label="银行流水(图片)：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bank_image">
          <transition-group>
            <div v-for="(item, index) in form.bank_image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <!-- <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bank_image')"><i class="el-icon-close"></i></a> -->
              </div>
            </div>
          </transition-group>
        </draggable>
        <!-- <div class="item img-select" @click="openProductUpload('bank_image')">
          <i class="el-icon-plus"></i>
        </div> -->
      </div>
    </el-form-item>


    

    <el-form-item label="银行流水(文件)：" prop="model.image">
      <div class="draggable-list">
        <div v-for="(item, index) in form.bank_file" :key="index">
              <div class="item">
                {{ item.real_name?item.real_name:item.name }}
                <!-- <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'files')">
                  <i class="el-icon-close"></i></a> -->

                  <div class="open" @click="opena(item.file_path)">打开文件</div>  
              </div>
            </div>
        <!-- <div class="item img-select" @click="openFileUpload('album')">
          <i class="el-icon-plus"></i>
        </div> -->
      </div>
    </el-form-item>


      
    <el-form-item label="工资表：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.staff_image">
          <transition-group>
            <div v-for="(item, index) in form.staff_image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <!-- <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'staff_image')"><i class="el-icon-close"></i></a> -->
              </div>
            </div>
          </transition-group>
        </draggable>
        <!-- <div class="item img-select" @click="openProductUpload('staff_image')">
          <i class="el-icon-plus"></i>
        </div> -->
      </div>
    </el-form-item>

    <el-form-item label="员工(文件)：" prop="model.image">
      <div class="draggable-list">
        <div v-for="(item, index) in form.staff_file" :key="index">
              <div class="item">
                {{ item.real_name?item.real_name:item.name }}
                <!-- <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'files')">
                  <i class="el-icon-close"></i></a> -->

                  <div class="open" @click="opena(item.file_path)">打开文件</div>  
              </div>
            </div>
        <!-- <div class="item img-select" @click="openFileUpload('album')">
          <i class="el-icon-plus"></i>
        </div> -->
      </div>
    </el-form-item>

       

        <el-form-item label="申报情况" prop="remark" v-if="form.audit_status == 1">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入申报情况" class="max-w460"></el-input></el-form-item>
      
       
          <el-form-item label="是否申报：" v-if="form.audit_status == 1">
          <el-radio-group v-model="form.is_declare">
            <el-radio :label="0">未申报</el-radio>
            <el-radio :label="1">已申报</el-radio>
 
          </el-radio-group>
        </el-form-item>

        <div v-if="form.audit_status == 0 || form.audit_status == 2">
            请先审核通过再进行申报处理
        </div>


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import ServiceApi from '@/api/service.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        remark: '',
        staff_image:[],
        bank_image:[],
        staff_file:[],
        bank_file:[],
        is_declare:0,
       
      },
      loading: false,
      /*验证规则*/
      rules: {
  
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","service_id",'service_info_id'],
  methods: {
    opena(file){
        window.open(file)
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      ServiceApi.detailInfo({service_id: self.service_id,service_info_id:self.service_info_id},true).then(res => {
          self.form = res.data;

        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.service_id = self.service_id;
      form.service_info_id = self.service_info_id
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ServiceApi.editInfo(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      console.log('this.code',this.code)
      console.log('e',e)
      if(this.code == 'bank_image'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bank_image.concat(e);
        this.$set(this.form, "bank_image", imgs);
      }
      }else  if(this.code == 'staff_image'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.staff_image.concat(e);
        console.log('imgs',imgs)
        this.$set(this.form, "staff_image", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'bank_image'){
        this.form.bank_image.splice(index, 1);
      }else if(code == 'staff_image'){
        this.form.staff_image.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
.open{
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 10px;

  color: #171717;

}
.openx{
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 10px;

  color: #171717;
  background: rgba(255, 255, 255, 0.5);

}
</style>



// WEBPACK FOOTER //
// src/views/plus/service/index/declare/part/edit.vue